import { createAction, props } from '@ngrx/store';
import { ActionType } from '../../../../../../libs/essentials/types/src/actionType';
import { Pharmacy } from '../../../../../../libs/essentials/types/src/pharmacy';

export const loadPharmacy = createAction(
  `${ActionType.WidgetPharmacy}: Load pharmacy data`,
  props<{ pharmacyId: string }>()
);
export const setPharmacy = createAction(
  `${ActionType.WidgetPharmacy}: Set pharmacy data`,
  props<{ pharmacy: Pharmacy }>()
);
export const loadPharmacyError = createAction(`${ActionType.WidgetPharmacy}: Load pharmacy error`);
